import assembleApp from 'help-center/core/assembleApp'
import { request } from 'gleam-shared/network/http'
import { unlockTinyFA } from 'gleam-shared/tinyFA'
import { createSSRApp } from 'vue'

request(window.sourceUrl).then((sourceFrame) => {
  const el = document.querySelector('[vue-widget-help-center]')
  const app = assembleApp(createSSRApp, sourceFrame)
  app.mount(el)
  unlockTinyFA()
})
